








































































































































































import Vue from 'vue';
import DropDown from '@/components/FormInputs/DropDown.vue';
// import Upload from '@/components/FormInputs/Upload.vue';
import Checkbox from '@/components/FormInputs/Checkbox.vue';

export default Vue.extend({
  name: 'AdminUser',
  components: {
    DropDown,
    // Upload,
    Checkbox,
  },
  data() {
    return {
      user: {},
      unternehmen: [],
      todelete: false,
      password1: '',
      password2: '',
      currentpassword: '',
    };
  },
  created() {
    this.$store
      .dispatch('loadUserData', this.uid)
      .then((results: any) => {
        this.user = results.data.message.user;
        return this.$store.dispatch('loadUnternehmenFromUser', this.user.id);
      })
      .then((result: any) => {
        this.unternehmen = result.data.message;
      });
  },
  methods: {
    saveUser: function() {
      this.$store.dispatch('saveUser', this.user).then(() => {
        this.$store.dispatch('addMessage', {
          message: 'User gespeichert',
          type: 'success',
        });
      });
    },
    setPassword: function(value) {
      if (this.password1 != this.password2) {
        this.$store.dispatch('addMessage', {
          message: 'Die Passwörter müssen übereinstimmen!',
          type: 'error',
        });
      } else {
        this.$store
          .dispatch('savePasswordAdmin', {
            id: this.user.id,
            newpw: this.password1,
          })
          .then((results) => {
            if (!results.data.message.success) {
              this.$store.dispatch('addMessage', {
                message: results.data.message.message,
                type: 'error',
              });
            } else {
              this.$store.dispatch('addMessage', {
                message: results.data.message.message,
                type: 'success',
              });
              this.password1 = '';
              this.password2 = '';
              this.currentpassword = '';
            }
          })
          .catch((err) => {
            this.$store.dispatch('addMessage', {
              message: 'Beim Speichern des Passwortes ist ein Fehler aufgetreten, bitte versuchen sie es später erneut.',
              type: 'error',
            });
          });
      }
    },
    branchename: function(id) {
      return this.$store.getters.getBranche(id).name;
    },
    setRole: function(value) {
      this.user.role = value;
    },
  },
  computed: {
    uid: function() {
      return this.$route.params.id;
    },
    roles: function() {
      return [
        { id: 'registered', name: 'registered' },
        { id: 'admin', name: 'admin' },
      ];
    },
  },
});
